import React from "react";
import { Route } from "react-router-dom";
import ProductDetail from "../products/ProductDetail";
import ProductAdd from "../products/ProductAdd";
import ProductEdit from "../products/ProductEdit";
import EditorReactFlow from "../flowchart/ReactFlow";

const allProductRoutes = () => (
  <>
    <Route
      path="/department/production-dashboard/product-list/add-product"
      element={<ProductAdd />}
    />
    <Route
      path="/department/production-dashboard/product-list/product/:slug/edit"
      element={<ProductEdit />}
    />
    <Route
      path="/department/production-dashboard/product-list/product/reactflow"
      element={<EditorReactFlow />}
    />
    <Route
      path="/department/production-dashboard/product-list/product/:slug"
      element={<ProductDetail />}
    />
  </>
);

export default allProductRoutes;
